// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import Check from '../../img/icons/16/check.svg';
import Chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import styles from './other_products.module.less';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Editor} from '../../../../shared/editor/editor';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

type t_product = 'sdp' | 'ddp' | 'isp' | 'isp_plus' | 'srp';

interface i_other_products_props {
    title?: string;
    title_tag?: string;
    prod: t_product;
}

export const Other_products = (props: i_other_products_props)=>{
    const products_data = {
        sdp: {
            title: 'Shared Datacenter Proxies',
            lines: [
                'Budget-friendly and effective',
                'Great for general tasks',
                'Cost-effective'
            ],
            price: 'Starting at $0.18/IP',
            to: get_new_link('/products/shared-datacenter'),
        },
        ddp: {
            title: 'Dedicated Datacenter Proxies',
            lines: [
                'Exclusive IPs, just for you',
                'Reliable and fast',
                'Ideal for sensitive tasks'
            ],
            price: 'Starting at $0.58/IP',
            to: get_new_link('/products/dedicated-datacenter'),
        },
        isp: {
            title: 'Global ISP Proxies',
            lines: [
                'Real-world IP addresses',
                'Browse like a local',
                'Worldwide coverage except US'
            ],
            price: 'Starting at $0.36/IP',
            to: get_new_link('/products/isp-proxy?type=isp'),
        },
        isp_plus: {
            title: 'Search Engine ISP Proxies',
            lines: [
                'Built for search scraping',
                'Optimized to avoid blocks',
                'Cost-Perfect for SEO and Social Media'
            ],
            price: 'Starting at $1.25/IP',
            to: get_new_link('/products/isp-proxy?type=isp_plus'),
        },
        srp: {
            title: 'Rotating Residential Proxies',
            lines: [
                'New IPs on rotation',
                'High anonymity, low detection',
                'Versatile for diverse needs'
            ],
            price: 'Starting at $1.38/GB',
            to: get_new_link('/products/residential-proxy'),
        },
    };
    const qs = use_qs();
    const {T, t} = use_translation_v({no_defaults: true});
    const {title, prod = 'srp'} = props;
    const selected_prod = prod.includes('isp') ? qs?.type || prod : prod;
    const {theme} = use_theme({def: 'toolip'});
    return <div className={cn(styles.other_products, styles.other_products_v2,
      styles[selected_prod])}>
      <div>
        <Dynamic_heading tag={props.title_tag || 'p'} className={cn(theme.p22,
          theme.med, theme.color_n700, styles.mb_48)}><T>{title ||
            'You might also be interested in...'}</T>
        </Dynamic_heading>
        <div className={cn(styles.cards, styles.cards_v2)}>
          {Object.keys(products_data).filter(k=>k!=selected_prod).map(k=>{
              const p = products_data[k];
              const card_cls = cn(styles[k], styles.card_v2, styles.card_v3);
              return <Link key={k} to={p.to} className={card_cls}>
                <div className={cn(styles.card_top, styles.card_top_v2)}>
                  <p className={cn(theme.p16,
                    theme.color_n600)}><b><T>{p.title}</T></b></p>
                </div>
                <div>
                {p.lines.map((v, i)=>
                  <div key={i} className={styles.lines_wrapper}>
                    <Check/>
                    <p className={cn(styles.li,
                      theme.p12, theme.med, theme.color_n500)}><T>{v}</T></p>
                  </div>
                )}
                </div>
                <div className={styles.card_btn_v2}>
                  <Button caption={<>{t(p.price)} <Chevron_right/></>}
                  w100={true} size="sm" round no_jump fit/>
                </div>
              </Link>;
          })}
        </div>
      </div>
  </div>;
};

interface i_other_products_editor_value {
    title: string;
    prod: string;
}

interface i_other_products_editor_props {
    value?: i_other_products_editor_value;
    on_change: (value: i_other_products_editor_value)=>void;
}

export const Other_products_editor = (props: i_other_products_editor_props)=>{
    const {value = {title: '', prod: 'srp'}, on_change} = props;
    type editor_key = keyof i_other_products_editor_value;
    type editor_type = 'text';
    const editors = [
        ['title', 'Section Title', 'text'],
        ['title_tag', 'Title Tag', 'select_tag_selector'],
        ['prod', 'Selected Product (sdp, ddp, isp, isp_plus, srp)', 'text']
    ].map(([key, label, type])=>({key: key as editor_key, label,
        type: type as editor_type}));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Other Products Editor"
    />;
};
